// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upload-modal {
  display: flex;
  flex-direction: column;
}

.upload-modal-header {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 25px;
}

.upload-area {
  width: 576px;
  min-height: 220px;
  border-radius: 12px;
  background: var(--Background-Secondary, #f4f4f4);
  justify-content: center;
  align-items: center;
  text-align: center;
  display: flex;
  flex-direction: column;
  cursor: pointer;
}

.error-area {
  width: 576px;
  min-height: 220px;
  border-radius: 12px;
  background: var(--Background-Secondary, #f4f4f4);
  justify-content: center;
  align-items: center;
  text-align: center;
  display: flex;
  flex-direction: column;
  word-break: break-all;
  padding: 27px 34px;
}

.upload-area form {
}

.modal-img {
  margin-right: 16px;
}

.card {
  flex-shrink: 0;
  border-radius: 12px;
  background: #fff;
  opacity: 1;
  padding: 0;
}

.card-header {
  display: flex;
  align-items: center;
  border-bottom: 0px !important;
  padding: 0;
}

.card-header-content {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0;
}

.card-header-content-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0;
}

.upload-modal-footer.MuiDialogActions-root {
  padding-top: 33px !important;
  min-height: 0px;
  display: flex;
  align-items: center;
  background: #fff;
  padding: 0;
}

.field-error-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: 52px;
  overflow-y: auto;
  padding: 0px 10px 0px 10px;
}

.field-error-item {
  display: flex;
  align-items: center;
  gap: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/PaymentReconciliation/uploadModal.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,gDAAgD;EAChD,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,gDAAgD;EAChD,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;AACA;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV","sourcesContent":[".upload-modal {\n  display: flex;\n  flex-direction: column;\n}\n\n.upload-modal-header {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  margin-bottom: 25px;\n}\n\n.upload-area {\n  width: 576px;\n  min-height: 220px;\n  border-radius: 12px;\n  background: var(--Background-Secondary, #f4f4f4);\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  cursor: pointer;\n}\n\n.error-area {\n  width: 576px;\n  min-height: 220px;\n  border-radius: 12px;\n  background: var(--Background-Secondary, #f4f4f4);\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  word-break: break-all;\n  padding: 27px 34px;\n}\n\n.upload-area form {\n}\n\n.modal-img {\n  margin-right: 16px;\n}\n\n.card {\n  flex-shrink: 0;\n  border-radius: 12px;\n  background: #fff;\n  opacity: 1;\n  padding: 0;\n}\n\n.card-header {\n  display: flex;\n  align-items: center;\n  border-bottom: 0px !important;\n  padding: 0;\n}\n\n.card-header-content {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding: 0;\n}\n\n.card-header-content-top {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  padding: 0;\n}\n\n.upload-modal-footer.MuiDialogActions-root {\n  padding-top: 33px !important;\n  min-height: 0px;\n  display: flex;\n  align-items: center;\n  background: #fff;\n  padding: 0;\n}\n\n.field-error-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  height: 52px;\n  overflow-y: auto;\n  padding: 0px 10px 0px 10px;\n}\n\n.field-error-item {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
